import React from 'react';
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import {
  CloseIconContainer,
  ModalContent,
  ModalBackground,
  ModalHeader,
  ModalBody,
  ModalText,
  StyledLink
} from './styles';

export default function ModalExpiredInDays({ modalOpenMessage, handleHideModal, days }) {
  return (
    <Modal
      open={modalOpenMessage}
      onClose={handleHideModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableBackdropClick 
    >
      <ModalBackground>
        <ModalHeader>
          <CloseIconContainer>
            <CloseIcon onClick={() => handleHideModal()} />
          </CloseIconContainer>
        </ModalHeader>
        <ModalBody>
          <ModalContent>
            <ModalText>
              {`Sua senha expira em ${days} dias.  `}
              <br/>{`Efetue a troca clicando `} 
              <StyledLink href="/recuperar-senha">
                aqui.
              </StyledLink>
            </ModalText>
          </ModalContent>
        </ModalBody>
      </ModalBackground>
    </Modal>
  );
}
